
/**
 * 合并拼接url
 * @param url url
 * @param query 查询参数
 */
export function jointUrl(url: string, query: { [i: string]: any } = {}) {
  const queryString = Object
    .keys(query)
    .reduce((pre, key) => {
      let value = query[key];
      if (key && value) {
        if (value instanceof Object) {
          value = JSON.stringify(value)
        }
        pre.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      }
      return pre;
    }, [] as string[])
    // .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
    .join('&');
  // queryString = queryString ? `?${queryString}` : queryString;
  if (!queryString) {
    return url;
  }
  // console.log(queryString, url)
  return url.indexOf('?') === -1 ? (url + '?' + queryString) : (url + '&' + queryString)
}

/**
 * 解析url中的query参数。
 * @param search window.location.search
 */
export function paseQuery(search = '') {
  const query: { [i: string]: string | null } = {}
  const href = (search || window.location.search).replace(/^\?/, '');
  if (href) {
    $.each(href.split('&'), (_index, item) => {
      const [key, value] = item.split('=');

      let value1 = null;
      if (value) {
        value1 = decodeURIComponent(value);
        if (/\[|\{/.test(value1)) {
          try {
            value1 = JSON.parse(value1)
          } catch (error) {

          }
        }

        value1 = value1.replace(/%20/g, ' ')
      }
      query[decodeURIComponent(key)] = value1
    });
  }
  return query;
}

/**
 * 根据key查询url中的查询参数
 * @param key
 */
export function queryByKey(key: string) {
  return paseQuery()[key] || null
}



// WEBPACK FOOTER //
// ./src/components/OYTool/url.ts